import React, { useState, useEffect } from "react";
import { createVacancy, updateVacancy } from "../../http/vacancyAPI";
import { fetchCategories } from "../../http/categoryAPI";
import "./AddVacancyForm.scss";

const AddVacancyForm = ({ vacancy, action, onSuccess }) => {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    nameAM: "",
    nameEN: "",
    nameRU: "",
    descriptionAM: "",
    descriptionEN: "",
    descriptionRU: "",
    salary: "",
    categoryId: ""
  });

  useEffect(() => {
    if (vacancy) {
      setFormData({
        id: vacancy.id ?? null,
        nameAM: vacancy.nameAM ?? "",
        nameEN: vacancy.nameEN ?? "",
        nameRU: vacancy.nameRU ?? "",
        descriptionAM: vacancy.descriptionAM ?? "",
        descriptionEN: vacancy.descriptionEN ?? "",
        descriptionRU: vacancy.descriptionRU ?? "",
        salary: vacancy.salary ?? "",
        categoryId: vacancy.categoryId ?? ""
      });
    }
  }, [vacancy]);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await fetchCategories();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (formData.id) {
        response = await updateVacancy(formData.id, formData);
        alert("Vacancy updated successfully!");
      } else {
        response = await createVacancy(formData);
        alert("Vacancy created successfully!");
      }
      if (onSuccess) onSuccess(response);

      if (!formData.id) {
        setFormData({
          id: null,
          nameAM: "",
          nameEN: "",
          nameRU: "",
          descriptionAM: "",
          descriptionEN: "",
          descriptionRU: "",
          salary: "",
          categoryId: ""
        });
      }
    } catch (error) {
      console.error("Error submitting vacancy:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="vacancy-form-container">
      <form onSubmit={handleSubmit} className="vacancy-form">
        {/* Names */}
        <div className="vacancy-row">
          <input
            type="text"
            name="nameAM"
            value={formData.nameAM}
            onChange={handleChange}
            required
            className="vacancy-input"
            placeholder="Անուն (Հայերեն)"
          />
          <input
            type="text"
            name="nameEN"
            value={formData.nameEN}
            onChange={handleChange}
            required
            className="vacancy-input"
            placeholder="Անուն (Անգլերեն)"
          />
          <input
            type="text"
            name="nameRU"
            value={formData.nameRU}
            onChange={handleChange}
            required
            className="vacancy-input"
            placeholder="Անուն (Ռուսերեն)"
          />
        </div>

        {/* Descriptions */}
        <div className="vacancy-row">
          <textarea
            name="descriptionAM"
            value={formData.descriptionAM}
            onChange={handleChange}
            required
            className="vacancy-textarea"
            placeholder="Նկարագրություն (Հայերեն)"
          />
          <textarea
            name="descriptionEN"
            value={formData.descriptionEN}
            onChange={handleChange}
            required
            className="vacancy-textarea"
            placeholder="Նկարագրություն (Անգլերեն)"
          />
          <textarea
            name="descriptionRU"
            value={formData.descriptionRU}
            onChange={handleChange}
            required
            className="vacancy-textarea"
            placeholder="Նկարագրություն (Ռուսերեն)"
          />
        </div>

        {/* Salary */}
        <div className="vacancy-row">
          <input
            type="number"
            name="salary"
            value={formData.salary}
            onChange={handleChange}
            className="vacancy-input"
            placeholder="Արժեք"
          />
        </div>

        {/* Category */}
        <div className="vacancy-row">
          <select
            name="categoryId"
            value={formData.categoryId}
            onChange={handleChange}
            className="vacancy-select"
          >
            <option value="">Ընտրել բաժին</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.nameEN}
              </option>
            ))}
          </select>
        </div>

        {/* Submit */}
        <div className="vacancy-row vacancy-row--submit">
          <button type="submit" className="vacancy-button">
            {action}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddVacancyForm;
